<template>
  <div class="map map-mini">
    <div class="map-inner" :id="id">
      <div class="static-marker">
        <i class="beepiz-marker"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { OutdoorMap } from "@/components/plans/map/OutdoorMapClass";

export default {
  data() {
    return {
      map: null,
      isProgrammaticMove: false,
    };
  },
  methods: {
    mapLoaded: function (e) {
      this.$emit("loaded");
    },

    handleMoveEnd: function () {
      if (!this.map || !this.map._map) {
        return;
      }

      // Ignore moveend events triggered by our own flyTo calls
      if (this.isProgrammaticMove) {
        this.isProgrammaticMove = false;
        return;
      }

      var center = this.map._map.getCenter();
      var zoom = this.map._map.getZoom();
      this.$emit("centerMap", {
        center: {
          lng: center.lng,
          lat: center.lat,
        },
        zoom: zoom,
      });
    },
  },
  mounted: function () {
    var vThis = this;

    var mapConfig = {
      logoPosition: "top-left",
      attributionControl: false,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [1.87635, 46.60559],
      zoom: 5,
      maxZoom: 22,
    };

    this.map = new OutdoorMap(this.id, mapConfig, this.mapLoaded);

    if (this.map && this.map._map) {
      this.map._map.on("moveend", this.handleMoveEnd);
    }
  },
  name: "minimap",
  props: ["center", "zoom", "id"],
  updated: function () {},
  watch: {
    center: function () {
      if (!this.map || !this.map._map || !this.center) {
        return;
      }
      this.isProgrammaticMove = true;
      this.map._map.flyTo({
        center: this.center,
        zoom: this.zoom,
        speed: 5,
      });
    },
    zoom: function () {
      if (!this.map || !this.map._map || !this.center) {
        return;
      }
      this.isProgrammaticMove = true;
      this.map._map.flyTo({
        center: this.center,
        zoom: this.zoom,
        speed: 5,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
